var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["Private"] = "private";
  CustomerType2["Company"] = "company";
  return CustomerType2;
})(CustomerType || {});
export {
  CustomerType
};
//# sourceMappingURL=types.js.map
